import { render, staticRenderFns } from "./setImport.vue?vue&type=template&id=176db7da&"
import script from "./setImport.vue?vue&type=script&lang=ts&"
export * from "./setImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports